export const isLoggedIn = () => {
  return {
    type: 'user/isLoggedIn',
  };
};
